var PayrollPeriodsService = (function () {
    function PayrollPeriodsService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    PayrollPeriodsService.prototype.getAll = function (CompanyID) {
        return this.$http.post(this.WsUrl + "/GetAllPayrollPeriods", {
            CompanyID: CompanyID
        });
    };
    PayrollPeriodsService.$inject = ["$http"];
    return PayrollPeriodsService;
}());
angular
    .module("London.Services")
    .service("PayrollPeriodsService", PayrollPeriodsService);
